import { render, staticRenderFns } from "./editcarbonfactor.vue?vue&type=template&id=257671e8&"
import script from "./editcarbonfactor.vue?vue&type=script&lang=ts&"
export * from "./editcarbonfactor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editcarbonfactor.vue"
export default component.exports